const callbacks = [];

export const useNg3DsRedirection = () => {
    function registerNgHsCallback() {
        ng_hs.onDeposit3dsRedirectionStart(async (ngCallback: () => void) => {
            callbacks.forEach(async (callback) => await callback());
            ngCallback();
        });
    }

    function beforeRedirection(callback: () => void) {
        callbacks.push(callback);
    }

    return {
        registerNgHsCallback,
        beforeRedirection,
    };
};
